export default "__VITE_ASSET__uqjdT9HH__"